module.exports = __webpack_public_path__ + "media/1.de036870.wav";